import styled from 'styled-components'
import { pxToRem } from 'styles/functions'

export const StyledFbContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${pxToRem(20)} 0;
  padding: 0 ${pxToRem(20)};
  width: 100%;
`

export const StyledFacebookButton = styled.a`
  color: white;
  background-color: #4267b2;
  display: flex;
  align-items: center;
  width: fit-content;
  max-width: 100%;
  padding: ${pxToRem(10)} ${pxToRem(30)} ${pxToRem(10)} 0;
  border-radius: ${pxToRem(3)};
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #6785c1;
  }

  i {
    width: ${pxToRem(20)};
    height: ${pxToRem(20)};
    padding: 0 ${pxToRem(20)};
    position: relative;

    svg {
      width: ${pxToRem(20)};
      height: ${pxToRem(20)};
    }

    &:after {
      content: '';
      width: ${pxToRem(1)};
      height: 100%;
      position: absolute;
      top: 0;
      right: ${pxToRem(-15)};
      background-color: white;
    }
  }

  label {
    padding-left: ${pxToRem(30)};
    text-align: start;
    cursor: pointer;
    font-weight: 700;
  }
`
